// extracted by mini-css-extract-plugin
export var completionBody = "_kr-2";
export var completionCard = "_kr-0";
export var completionFooter = "_kr-3";
export var completionTitle = "_kr-1";